var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Certificates","description":"Generate certificates for eligible students and verify issued credentials.","count-label":"certificate tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }